export const CssVariables = {
  ALIGN: {
    HORIZONTAL: '--horizontal-align',
  },
}
